import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-placeholder-with-text',
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './placeholder-with-text.component.html',
  styleUrl: './placeholder-with-text.component.css',
})
export class PlaceholderWithTextComponent implements OnChanges {
  @Input() formGroup!: FormGroup;
  @Input() fields: any;
  @Input() activeModalContext: any;

  hasImageError = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fields']) {
      this.hasImageError = false;
    }
  }

  getImageSrc(): string {
    if (this.hasImageError) {
      return this.getFallbackImage();
    }

    const customImage = this.fields?.uiOptions?.image || this.fields?.image;
    if (customImage) {
      return customImage;
    }

    return this.getFallbackImage();
  }

  getFallbackImage(): string {
    const customImage = (
      this.fields?.uiOptions?.image ||
      this.fields?.image ||
      ''
    ).toLowerCase();
    const fieldName = (this.fields?.fieldName || '').toLowerCase();
    const displayName = (this.fields?.displayName || '').toLowerCase();
    const text = (this.fields?.uiOptions?.text || '').toLowerCase();
    const helpText = (this.fields?.helpText || '').toLowerCase();
    const subText = (this.fields?.uiOptions?.subText || '').toLowerCase();

    const combinedText = `${customImage} ${fieldName} ${displayName} ${text} ${helpText} ${subText}`;

    // 1. Inactive / Inactivate
    if (
      combinedText.includes('inact') ||
      combinedText.includes('deactivat') ||
      combinedText.includes('inacitve')
    ) {
      return './assets/media/octy-images/inactive.png';
    }

    // 2. Suspend
    if (combinedText.includes('suspend')) {
      return './assets/media/octy-images/suspend.png';
    }

    // 3. Archive
    if (combinedText.includes('archiv')) {
      return './assets/media/octy-images/archived.png';
    }

    // 4. Active
    if (combinedText.includes('active') || combinedText.includes('reactivat')) {
      return './assets/media/octy-images/active.png';
    }

    // 5. Delete / Confirmation
    if (
      combinedText.includes('delete') ||
      combinedText.includes('remove') ||
      combinedText.includes('trash')
    ) {
      return './assets/media/octy-images/delete.png';
    }

    // 6. Success / Assignment / Complete
    if (
      combinedText.includes('success') ||
      combinedText.includes('sucsses') ||
      combinedText.includes('successful') ||
      combinedText.includes('assignment') ||
      combinedText.includes('completed')
    ) {
      return './assets/media/octy-images/sucsses.png';
    }

    // 7. Failed / Retry / Connection Error
    if (
      combinedText.includes('retry') ||
      combinedText.includes('fail') ||
      combinedText.includes('failed') ||
      combinedText.includes('error') ||
      combinedText.includes('connection') ||
      combinedText.includes('wazuh')
    ) {
      return './assets/media/octy-images/retry.png';
    }

    // 8. Warning / Confirmation
    if (combinedText.includes('warn')) {
      return './assets/media/octy-images/warning.png';
    }

    // 9. Invite
    if (combinedText.includes('invite')) {
      return './assets/media/octy-images/invite.png';
    }

    // 10. Verify Email
    if (combinedText.includes('verify') || combinedText.includes('email')) {
      return './assets/media/octy-images/verifyEmail.png';
    }

    // Default fallback
    return './assets/media/octy-images/retry.png';
  }

  handleImageError(event: Event): void {
    if (!this.hasImageError) {
      this.hasImageError = true;
      const target = event.target as HTMLImageElement;
      if (target) {
        target.src = this.getFallbackImage();
      }
    }
  }

  resolvePlaceholders(text: string): string {
    if (!text) return text;

    const placeholderRegex = /{{(.*?)}}/g;

    return text.replace(placeholderRegex, (_match, key) => {
      key = key.trim();

      // 1. direct component property
      if ((this as any)[key] !== undefined) {
        return (this as any)[key];
      }
      // 2. modal context
      if (
        this.activeModalContext &&
        this.activeModalContext[key] !== undefined
      ) {
        return this.activeModalContext[key];
      }

      return _match; // fallback
    });
  }
}
